import { render, staticRenderFns } from "./ReleaseTrackMusicUploader.vue?vue&type=template&id=0f8b20d3&scoped=true&"
import script from "./ReleaseTrackMusicUploader.vue?vue&type=script&lang=js&"
export * from "./ReleaseTrackMusicUploader.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseTrackMusicUploader.vue?vue&type=style&index=0&id=0f8b20d3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8b20d3",
  null
  
)

export default component.exports